import { createContext, useContext } from "react";

const PosSessionPromptContext = createContext(null);

export const PosSessionPromptProvider = PosSessionPromptContext.Provider;

export const usePosSessionPrompt = () => {
  const context = useContext(PosSessionPromptContext);
  if (!context) {
    throw new Error(
      "usePosSessionPrompt must be used within a POS session prompt provider.",
    );
  }
  return context;
};
